var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#073C50",
    fillRule: "evenodd",
    d: "M37,42 L37,48 L11,48 L11,42 L37,42 Z M48,0 L48,38 L0,38 L0,0 L48,0 Z M43,5 L5,5 L5,33 L43,33 L43,5 Z M24.7990893,9.41088029 L28.6216215,10.5891197 L22.9112661,29.1150804 L19.0887339,27.936841 L24.7990893,9.41088029 Z M14.4319423,12.6085844 L17.3052419,15.3914156 L13.791,19.019 L17.297747,22.6008874 L14.4394372,25.3991126 L8.20848312,19.0343652 L14.4319423,12.6085844 Z M33.0742879,12.6085844 L39.3052419,18.9733319 L33.0817828,25.3991126 L30.2084831,22.6162815 L33.722725,18.9886971 L30.215978,15.4068097 L33.0742879,12.6085844 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/Network.6a775896e641c84bccf0bbccab872fc7.svg";
export { ForwardRef as ReactComponent };